<div class="change-applicant-modal">
    <dw-meta-data-form #mdForm item="CheckRideRequest" [(data)]="refCheckride" (dataChanged)="dataChanged($event)"
        [overrideData]="true" configKeyPart="applicant-swap" [handleRedirect]="false" [showButtons]="false"
        [isModal]="true" formMode="edit"></dw-meta-data-form>


    <div dwRow *ngIf="currentCheckride">
        <div dwCol="12">
            <dw-meta-data-form #mdForm item="CheckRideRequest" [(data)]="currentCheckride" [overrideData]="true"
                configKeyPart="applicant-swap-existing" [handleRedirect]="false" [showButtons]="false" [isModal]="true"
                formMode="edit"></dw-meta-data-form>
        </div>
    </div>

    <div *ngIf="showCancelSwapOptions" dwRow>
        <div dwCol="12">
            <label class="dw-orange">{{cancelSwapText}}</label>
            <!-- <div *ngIf="currentAirportInfo && currentCheckride?.ScheduledDateTime">
                Checkride Date/Time: <app-date-time-display-control [dateTime]="currentCheckride?.ScheduledDateTime"
                    [airportInfo]="currentAirportInfo"></app-date-time-display-control>
            </div> -->
            <dw-radio-list [values]="cancelSwapOptions" [(ngModel)]="cancelSwapValue" [disabled]="!allowSwap"
                (ngModelChange)="handleCancelSwapChange()"></dw-radio-list>
        </div>
    </div>

    <dw-message [(message)]="message"> </dw-message>

    <dw-loading [show]="validationStarted" [text]="'Validating changes'"></dw-loading>
    <dw-loading [show]="saving" [text]="savingMessage"></dw-loading>

    <div *ngIf="allowOverride && isValidForOverride && !saving && !validationStarted"> 
        <button (click)="overrideErrors=true" class="btn btn-warning" *ngIf="!overrideErrors">Override Validation
            Errors</button>

        <div *ngIf="overrideErrors">
            <div class="alert alert-warning">
                <strong>Warning:</strong> You have chosen to override the validation errors for this applicant swap. 
            </div>
        </div>

    </div>
</div>